<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.billOfLadingInquiry')"
    :width="$selectByLang('300px', '340px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('60px', '80px')" label-position="left">
      <el-form-item :label="$t('CargoMsg.Cargo_BLNo')+'：'">
        <el-input v-model="value" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'QueryMblDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      value: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.value = ''
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    clickHandler() {
      if (!this.value) {
        this.$message.info(this.$t('queryJob.enterBillOfLadingNumber'))
        return
      }
      this.$emit('callback', this.value)
      this.innerVisible = false
    }
  }
}
</script>
